'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("journalOffreService", function ($modal) {
  return {
    // edition / creation
    /**
     *
     * @param offre pour une nouvelle offre déjà remplie, passer une offre sans id. passer null pour creer une offre de 0.
     * @returns {*}
     */
    openOffreEBEditionPopin: function openOffreEBEditionPopin($scope, offre, copieId) {
      var newOffre = null;
      if (offre != null && offre.id == null) {
        newOffre = offre;
      }
      return $modal.open({
        scope: $scope,
        controller: "OffreEBEditionPopinController",
        template: require("./edition/offreEBEditionPopin.html"),
        vars: {
          edit: offre && offre.id != null ? true : false,
          offreId: offre && offre.id,
          copieId: copieId,
          newOffre: newOffre
        },
        options: {
          width: 750
        }
      });
    },
    // edition / creation
    /**
     *
     * @param offre pour une nouvelle offre déjà remplie, passer une offre sans id. passer null pour creer une offre de 0.
     * @returns {*}
     */
    openOffreLTEditionPopin: function openOffreLTEditionPopin($scope, offre, copieId) {
      var newOffre = null;
      if (offre != null && offre.id == null) {
        newOffre = offre;
      }
      return $modal.open({
        scope: $scope,
        controller: "OffreLTEditionPopinController",
        template: require("./edition/offreLTEditionPopin.html"),
        vars: {
          edit: offre && offre.id != null ? true : false,
          offreId: offre && offre.id,
          copieId: copieId,
          newOffre: newOffre
        },
        options: {
          width: 750
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/journalOffres/journalOffreService.js
// module id = 2833
// module chunks = 13